import { DragEvent, FC, Fragment, useRef, useState } from "react";
import styled from "styled-components";
import { useChat } from "../../../hooks/useChat";

const DragWrapper = styled("div")`
  width: 100%;
  height: 100%;
  position: relative;
`;

const DraggingContainer = styled("div")`
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  right: 7px;
  bottom: 7px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  z-index: 9999;
  padding: 8px;
`;

const DraggingContent = styled("div")`
  border: dashed 4px ${(props) => props.theme.colors.secondary};
  border-radius: 4px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;

  justify-content: center;
  align-items: center;
`;

const DraggingText = styled("span")`
  padding: 16px;
  color: ${(props) => props.theme.colors.secondary};
  text-align: center;
  font-weight: 700;
  font-size: 1.3rem;
`;

interface IDragAndDropProps {
  disabled: boolean;
  children: any;
}

const DragAndDrop: FC<IDragAndDropProps> = ({ children, disabled }) => {
  const [dragging, setDragging] = useState<boolean>(false);
  const dragCounter = useRef(0);
  const { addFiles } = useChat();

  // Lida com os eventos de Drag
  const handleDrag = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    switch (event.type) {
      case "dragenter":
        dragCounter.current++;
        if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
          setDragging(true);
        }
        break;
      case "dragleave":
        dragCounter.current--;
        if (dragCounter.current === 0) {
          setDragging(false);
        }
        break;
      default:
        break;
    }
  };

  // Função chamada quando usuário "soltar" os arquivos dentro do elemento
  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();

    setDragging(false);
    dragCounter.current = 0;

    const { files: dragFiles } = event.dataTransfer;
    if (!disabled) {
      addFiles(dragFiles);
    }
  };

  return (
    <DragWrapper
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <Fragment>
        {dragging && !disabled && (
          <DraggingContainer>
            <DraggingContent>
              <DraggingText>Solte o arquivo para anexar! :D</DraggingText>
            </DraggingContent>
          </DraggingContainer>
        )}
        {children}
      </Fragment>
    </DragWrapper>
  );
};

export default DragAndDrop;
